module.exports = __webpack_public_path__ + "media/svg/help-2be860be.svg";